// import local dependencies
import jQuery from 'jquery';
import Alpine from 'alpinejs';
import notie from 'notie';

import Router from './util/Router';
// import phraseChanger from './util/phraseChanger';
import appState from './util/appState';

import common from './routes/common';
import home from './routes/home';
import pay from './routes/pay';
import jobs from './routes/jobs';
import daily from './routes/daily';
import user from './routes/user';
import clients from './routes/clients';

window.$ = window.jQuery = jQuery;
window.Alpine = Alpine;
window.notie = notie;

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
  home,
  pay,
  jobs,
  daily,
  user,
  clients,
});

// Init phrase swapper
// phraseChanger.init();

appState.init();

// Load Events
document.addEventListener('DOMContentLoaded', () => routes.loadEvents());

Alpine.start();
